// Account Statements Payable Mutations

export const setStatementList = (state, payload) => {
  state.statementList = payload
}

export const setStatementInfo = (state, payload) => {
  state.statementInfo = payload
}
